import btag from '../../middleware/btag'

export default btag
